import React from 'react';
import { Batiment } from '../../../../shared/types/game';

/** Onglet « Cellules » — port fidèle du prototype (`buildings.js` tabHebergement). */

interface BuildingCellulesTabProps {
  building: Batiment;
  onIncreaseCapacity?: () => void;
}

const pad = (n: number) => String(n).padStart(2, '0');

const BuildingCellulesTab: React.FC<BuildingCellulesTabProps> = ({ building, onIncreaseCapacity }) => {
  const cap = building.capacite || 0;
  const occ = Math.min(cap, building.postes_occupes || 0);
  const isPrison = building.type === 'prison';

  return (
    <div className="block">
      <div className="block__h">
        Cellules <span className="mono muted">{occ}/{cap} occupée(s)</span>
      </div>
      <div className="block__b">
        <p className="bsub">
          La capacité d'hébergement suit la capacité personnel du site (<span className="mono">player_building.capacite</span>) :
          {' '}{cap} cellule(s) au niveau {building.niveau ?? 1}.
        </p>
        {cap === 0 ? (
          <div className="empty">Aucune cellule. La capacité augmente avec le niveau et les extensions.</div>
        ) : (
          <div className="cells">
            {Array.from({ length: cap }, (_, i) => (
              <div className={`cell ${i < occ ? 'is-full' : ''}`} key={i}>
                <span className="cell__n mono">{pad(i + 1)}</span>
                <span className="cell__s">{i < occ ? 'occupée' : 'libre'}</span>
              </div>
            ))}
          </div>
        )}
        {isPrison && onIncreaseCapacity ? (
          <button className="btn btn--sm btn--ghost btn--block" style={{ marginTop: 9 }} type="button" onClick={onIncreaseCapacity}>
            + Augmenter la capacité
          </button>
        ) : null}
        <p className="bwarn" style={{ marginTop: 8 }}>
          ⚠ L'occupation est indicative : aucune table de détenus n'existe encore en base.
        </p>
      </div>
    </div>
  );
};

export default BuildingCellulesTab;
